import img3 from "../../../assets/user5.jpeg";

const TestimonialCard = () => {
  return (
    <div className="max-w-5xl mx-auto my-6 lg:my-16 py-10 lg:py-14 px-6 lg:px-12 bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200 rounded-3xl flex flex-col lg:flex-row items-center gap-8 relative overflow-hidden">
      <div className="absolute -top-20 -right-20 w-48 h-48 bg-slate-200 rounded-full opacity-20"></div>
      <div className="absolute -bottom-20 -left-20 w-48 h-48 bg-slate-200 rounded-full opacity-20"></div>

      <div className="w-32 h-32 lg:w-40 lg:h-40 rounded-full overflow-hidden flex-shrink-0 border-4 border-white shadow-lg relative z-10">
        <img
          src={img3}
          alt="User"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="text-center lg:text-left relative z-10">
        <svg
          className="w-8 h-8 text-slate-400 mx-auto lg:mx-0 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          ></path>
        </svg>
        <h3 className="text-2xl lg:text-3xl font-bold text-slate-800">
          "A Game-Changer for Email Discovery"
        </h3>
        <p className="text-slate-600 text-lg italic mt-4">
          This tool has completely transformed how I find emails. It's fast,
          accurate, and incredibly easy to use.
        </p>
        <p className="text-slate-700 mt-4 text-lg leading-relaxed">
          The intuitive interface and powerful features make it a must-have for
          anyone in sales or marketing. The support team is also
          fantastic—always quick to help!
        </p>
        <p className="text-sm text-slate-500 mt-6 font-medium italic">
          — Adam M. <span className="text-slate-400">| Founder and CEO</span>
        </p>
      </div>
    </div>
  );
};

export default TestimonialCard;
